<template>
  <div>
    <v-card class="quoteSideInfo">
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{motorIcon}}</v-icon>
          Motor
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top v-if="!query">
          <v-btn flat slot="activator" @click="doSave()" :loading="quotation.saving">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
          <span>Save Quotation/Proposal</span>
        </v-tooltip>
        <!-- <v-tooltip top v-if="query">
          <v-btn flat slot="activator" @click="printQuote">
            Print Quote
            <v-icon right>mdi-printer</v-icon>
          </v-btn>
          <span>Print Quotation</span>
        </v-tooltip> -->
        <v-tooltip top>
          <v-menu bottom left slot="activator">
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="promptNTU = true">
                <v-list-tile-title>Not Taken Up</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="promptVoid = true">
                <v-list-tile-title>Void</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="promptRevert = true" v-if="checkAccess(['motorQuoteRevertNQ'])">
                <v-list-tile-title>Revert to New Quotation</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <span>More Options</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <v-subheader class="queryLabel">Quotation No.</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span class="title">{{commonForm.proposalNo}}</span>
            </v-flex>
            <template v-if="commonInfo.premium.premiumPayable">
              <v-flex xs4>
                <v-subheader class="queryLabel">Premium Payable</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{currPrefix}}{{formatDisplayNumber(commonInfo.premium.premiumPayable)}}</span>
              </v-flex>
            </template>
            <v-flex xs4>
              <v-subheader class="queryLabel">Current Status</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span :class="currentStatusClass">{{currentStatusLabel}}</span>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">Intermediary</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span>{{commonForm.intermediary}} - {{queryInfo.intermediary}}</span>
            </v-flex>
            <template v-if="commonForm.product">
              <v-flex xs4>
                <v-subheader class="queryLabel">Product</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{commonForm.product}} - {{queryInfo.product}}</span>
              </v-flex>
            </template>
            <template v-if="motorForm.busCls">
              <v-flex xs4>
                <v-subheader class="queryLabel">Business Class</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{motorForm.busCls}} - {{queryInfo.busCls}}</span>
              </v-flex>
            </template>
            <template v-if="motorForm.tariff">
              <v-flex xs4>
                <v-subheader class="queryLabel">Tariff</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{motorForm.tariff}} - {{queryInfo.tariff}}</span>
              </v-flex>
            </template>
            <template v-if="motorForm.cover">
              <v-flex xs4>
                <v-subheader class="queryLabel">Type of Cover</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{motorForm.cover}} - {{queryInfo.cover}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.acceptDate">
              <v-flex xs4>
                <v-subheader class="queryLabel">Acceptance Date</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDisplayDateTime2(commonForm.acceptDate)}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.startDate">
              <v-flex xs4>
                <v-subheader class="queryLabel">Start Date</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDate(commonForm.startDate)}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.endDate">
              <v-flex xs4>
                <v-subheader class="queryLabel">End Date</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDate(commonForm.endDate)}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.campaign">
              <v-flex xs4>
                <v-subheader class="queryLabel">Campaign</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{commonForm.campaign}} - {{queryInfo.campaign}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.promotion">
              <v-flex xs4>
                <v-subheader class="queryLabel">Promotion</v-subheader>
              </v-flex>
              <v-flex xs7>
                <span>{{commonForm.promotion}} - {{queryInfo.promotion}}</span>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <confirm v-model="promptNTU" @ok="doNTU">
      Confirm that you want to change the status of this Quotation to
      <b>Not Taken Up</b>?
    </confirm>
    <confirm v-model="promptVoid" @ok="doVoid">
      Confirm that you want to change the status of this Quotation to
      <b>Void</b>?
    </confirm>
    <confirm v-model="promptRevert" @ok="doRevert">
      Confirm that you want to revert the status of this Quotation to
      <b>New Quotation</b>?
    </confirm>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AGENCY_QUOTATION_LEAVEQUOTE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { quoteStatus, appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      promptNTU: false,
      promptVoid: false,
      promptRevert: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    currentStatusLabel() {
      if (quoteStatus[this.quotation.commonInfo.statusCode]) {
        return quoteStatus[this.quotation.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    currentStatusClass() {
      if (this.quotation.commonInfo.statusCode === 'QD' || this.quotation.commonInfo.statusCode === 'PD' || this.quotation.commonInfo.statusCode === 'VO' || this.quotation.commonInfo.statusCode === 'NTU' || this.quotation.commonInfo.statusCode === 'CL') {
        return 'error--text'
      } else if (this.quotation.commonInfo.statusCode === 'QPA' || this.quotation.commonInfo.statusCode === 'PPA') {
        return 'warning--text'
      } else if (this.quotation.commonInfo.statusCode === 'IF' || this.quotation.commonInfo.statusCode === 'PO') {
        return 'success--text'
      } else {
        return ''
      }
    },
    motorForm() {
      return this.quotation.motorForm
    },
    commonForm() {
      return this.quotation.commonForm
    },
    commonInfo() {
      return this.quotation.commonInfo
    },
    queryInfo() {
      return this.quotation.queryInfo
    },
    motorIcon() {
      return appIcon.MOTOR
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime2(date) {
      return formatDisplayDateTime2(date)
    },
    doSave() {
      // Emit saving event on global event bus
      // Each quote page should listen to this and do partial Submit and save
      this.$root.$emit('saveQuote')
    },
    printQuote() {
      this.$snotify.warning('Feature Coming Soon!')
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    doNTU() {
      this.$root.$emit('ntu')
    },
    async doVoid() {
      this.$root.$emit('void')
    },
    async doRevert() {
      try {
        await this.$store.dispatch('revertMtrQuote')

        this.$snotify.success('Quotation reverted to New Quotation')
        this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
        this.$router.push({ name: 'motorQuote' })
      } catch (err) {
        this.notify(err)
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    query: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@media (min-width: 1264px) {
  .quoteSideInfo {
    // Module specific override
    min-height: 425px;
  }
}

.permitStatus {
  padding-left: 20px;
}
</style>
